



















import { Component, Mixins } from 'vue-property-decorator'
import GlobalMixin from '@/mixins/globalMixin'
import LoadingComponent from '@/components/LoadingComponent.vue'
import AlertBarComponent from '@/components/AlertBarComponent.vue'

@Component({
  components: {
    LoadingComponent,
    AlertBarComponent,
  },
})
export default class Home extends Mixins(GlobalMixin) {
  mounted() {
    this.$router.push("/login")
  }
}
